<div class="success-wrapper">
  <div class="left">
    <img *ngIf="registration.logo" [src]="registration.logo | safe" />
    <span class="text" [innerHtml]="settings.successText | safeHTML"></span>
    <span class="headline" [innerHtml]="settings.successTitle | safeHTML"></span>
    <button class="button" (click)="techCheck()" mat-flat-button color="primary">{{ settings.techCheckText }}</button>
    <button class="button" (click)="goToPlattform()" mat-flat-button color="primary">{{ settings.successButton }}</button>
  </div>
  <div class="right image-div" *ngIf="registration.image">
    <img [src]="registration.image | safe" />
  </div>
  <div class="right" *ngIf="!registration.image"></div>
</div>
